/* Drippy collection v2.
   Two additions to the theme's grid, both done from outside it:
     1. a Product / Model toggle that flips every card to its second image
     2. the finish of the piece where the card said "Ships tomorrow"
   Nothing here forks product-card.liquid, which is shared with search and
   related products. */
(function () {
  var KEY = 'drippy:coll-view';

  /* The heading reads "Collection: Bracelets". The first word is a label for
     a thing the shopper is already looking at, so it is dropped, and the
     collection's own description goes underneath it — that copy used to be
     printed over a full-bleed photo occupying the first cell of the grid. */
  function heading() {
    var h1 = document.querySelector('.collection-hero__title, .collection-hero h1');
    if (!h1) return;

    if (!h1.dataset.collv2) {
      // the label sits in a visually-hidden span and is translated
      // ("Collectie:", "Kollektion:"), so drop the span, not an English word
      [].slice.call(h1.querySelectorAll('.visually-hidden')).forEach(function (n) { n.remove(); });
      h1.textContent = h1.textContent.replace(/^\s*collection\s*:\s*/i, '').trim();
      h1.dataset.collv2 = '1';
    }

    var tpl = document.getElementById('collv2-desc');
    if (!tpl || document.querySelector('.collv2-desc')) return;

    /* A <template>'s children live in a separate document fragment, so
       textContent on the element itself is always empty — it has to be read
       from .content. */
    var text = ((tpl.content ? tpl.content.textContent : tpl.textContent) || '').trim();
    if (!text) return;

    var p = document.createElement('p');
    p.className = 'collv2-desc';
    p.textContent = text;
    h1.parentNode.insertBefore(p, h1.nextSibling);
  }

  /* Finish products are separate products with a predictable handle suffix.
     Longest first so "-925-white-gold" is not eaten by "-white-gold". */
  var SUFFIXES = [
    ['-925-white-gold', 'White gold finish'],
    ['-925-18k-gold', '18K gold finish'],
    ['-white-gold', 'White gold finish'],
    ['-18k-gold', '18K gold finish'],
    ['-14k-gold', '14K gold finish']
  ];

  /* Finishes computed in Liquid for every product in this collection, keyed
     by handle. The suffix rules below stay as a fallback for a card that
     arrives from somewhere this map does not cover. */
  var FINISH_MAP = (function () {
    var tag = document.getElementById('collv2-finish');
    if (!tag) return {};
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return {};
    }
  })();

  /* Reads the card's own title, the same test the PDP finish row and the spec
     table use, so the grid can never state a different finish from the product
     page. The Liquid map is preferred where it covers the product, but it only
     carries the collection's first page, so it cannot be the only source —
     59 cards past that limit were being left blank. */
  function fromTitle(t) {
    var T = (t || '').toUpperCase();
    if (T.indexOf('WHITE GOLD') > -1) return 'White gold finish';
    if (T.indexOf('14K') > -1) return '14K gold finish';
    if (T.indexOf('GOLD') > -1 || T.indexOf('18K') > -1) return '18K gold finish';
    return null;
  }

  function finishFor(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var handle = '';
    if (link) {
      handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0];
      if (FINISH_MAP[handle]) return FINISH_MAP[handle];
    }

    var titleEl = card.querySelector('.card__title a, .card__heading a, .card__title, .card__heading');
    var byTitle = fromTitle(titleEl ? titleEl.textContent : (link ? link.getAttribute('title') : ''));
    if (byTitle) return byTitle;

    for (var i = 0; i < SUFFIXES.length; i++) {
      var suf = SUFFIXES[i][0];
      if (handle.length > suf.length && handle.slice(-suf.length) === suf) return SUFFIXES[i][1];
    }

    /* Everything left is 925 silver with a rhodium finish — which is what the
       product page calls White Gold, so the card says the same. */
    return 'White gold finish';
  }

  function labelCards(root) {
    var cards = (root || document).querySelectorAll('.collection-product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      /* 2026-09-30: product-card.liquid now prints finish + base metal itself
         (.cro-card-spec, translated). Nothing to do for those cards. */
      if (card.querySelector('.cro-card-spec')) continue;
      var slot = card.querySelector('.cro-card-ships');

      /* The theme omits the shipping line entirely on a sold-out card, which
         left those 17 cards with no finish and no info at all. Make the slot
         rather than skip the card. */
      if (!slot) {
        var host = card.querySelector('.card-information__group');
        if (!host) continue;
        slot = document.createElement('div');
        slot.className = 'cro-card-ships';
        host.appendChild(slot);
      }

      if (slot.dataset.v2Finish) continue;
      var finish = finishFor(card);
      slot.hidden = false;
      slot.textContent = finish;
      slot.classList.add('coll-v2-finish');
      slot.dataset.v2Finish = '1';
    }
  }


  function applyView(mode, root) {
    var cards = (root || document).querySelectorAll('.collection-product-card');
    for (var i = 0; i < cards.length; i++) {
      var target = mode === 'model' ? 1 : 0;
      /* QA round 2: the card's extra photos carry no source until hovered
         (data-dsrc, layout/theme.liquid). Model view shows slide 2 on every
         card, so fill that photo across the whole grid (also before Swiper
         has initialised); the other slides stay deferred. */
      if (mode === 'model') {
        var slide2 = cards[i].querySelectorAll('.swiper-slide')[1];
        var imgs = slide2
          ? slide2.querySelectorAll('img[data-dcard-defer]')
          : cards[i].querySelectorAll('img.media--second[data-dcard-defer]');
        for (var j = 0; j < imgs.length; j++) {
          var im = imgs[j];
          if (im.dataset.dsrcset) im.setAttribute('srcset', im.dataset.dsrcset);
          if (im.dataset.dsrc) im.setAttribute('src', im.dataset.dsrc);
          im.removeAttribute('data-dcard-defer');
        }
      }
      var sw = cards[i].querySelector('.swiper');
      if (!sw || !sw.swiper) continue;
      if (sw.swiper.slides && sw.swiper.slides.length > target) {
        sw.swiper.slideTo(target, 0);
      }
    }
  }

  function currentMode() {
    try {
      return localStorage.getItem(KEY) === 'model' ? 'model' : 'product';
    } catch (e) {
      return 'product';
    }
  }

  function buildToggle() {
    if (document.querySelector('.coll-v2-toggle')) return;

    /* Into the toolbar itself, between Filter and Sort By, so it inherits the
       sticky behaviour and travels with the bar on scroll. */
    var bar = document.querySelector('.facets__sort-wrapper');
    var sorting = bar ? bar.querySelector('.facets-sorting') : null;
    if (!bar) return;

    var T = window.COLLV2_T || {};
    var wrap = document.createElement('div');
    wrap.className = 'coll-v2-toggle';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', T.v_aria || 'How products are shown');

    ['product', 'model'].forEach(function (mode) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.mode = mode;
      b.textContent = mode === 'product' ? (T.v_product || 'Product') : (T.v_model || 'Model');
      wrap.appendChild(b);
    });

    if (sorting) bar.insertBefore(wrap, sorting);
    else bar.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-mode]');
      if (!b) return;
      var mode = b.dataset.mode;
      try { localStorage.setItem(KEY, mode); } catch (err) {}
      paintToggle(mode);
      applyView(mode);
    });

    paintToggle(currentMode());
  }

  function paintToggle(mode) {
    var btns = document.querySelectorAll('.coll-v2-toggle button[data-mode]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(btns[i].dataset.mode === mode));
    }
  }

  /* Show more (Johannes 2026-10-01): the page holds up to 48 pieces so the
     sold-out ones really sit last; 24 show, the button reveals the rest and,
     on a collection bigger than one page, then loads the next page. */
  var STEP = 24;
  function showMore() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.v2More) return;
    grid.dataset.v2More = '1';
    var T = window.COLLV2_T || {};
    var items = Array.prototype.slice.call(grid.children);
    var total = Number(grid.dataset.total) || items.length;
    var offset = Number(grid.dataset.offset) || 0;
    var next = grid.dataset.next || '';
    var shown = Math.min(STEP, items.length);
    items.forEach(function (li, i) { if (i >= shown) li.classList.add('collv2-more-hidden'); });

    var foot = document.createElement('div');
    foot.className = 'collv2-more';
    var count = document.createElement('p');
    count.className = 'collv2-more__count';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collv2-more__btn';
    btn.textContent = T.more || 'Show more';
    foot.appendChild(count);
    foot.appendChild(btn);
    grid.parentNode.insertBefore(foot, grid.nextSibling);

    function paint() {
      var seen = offset + shown;
      count.textContent = (T.showing || 'Showing {{ shown }} of {{ total }}').replace(/\{\{\s*shown\s*\}\}/, seen).replace(/\{\{\s*total\s*\}\}/, total);
      foot.hidden = seen >= total;
    }
    btn.addEventListener('click', function () {
      if (shown < items.length) {
        shown = Math.min(shown + STEP, items.length);
        items.forEach(function (li, i) { if (i < shown) li.classList.remove('collv2-more-hidden'); });
        paint();
      } else if (next) {
        window.location.href = next;
      }
    });
    paint();
  }

  /* Finish swatches in the filter (Johannes 2026-10-01): a metal dot in front
     of White gold / Gold / Silver / Rose gold, the same dots as the PDP. */
  function swatches() {
    var labels = document.querySelectorAll('.facets__item label, .facets__list label, .facet-checkbox');
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (l.querySelector('.collv2-dot')) continue;
      var t = (l.textContent || '').toLowerCase();
      var tone = '';
      if (/white|wei|blanc|bianco|blanco|branco|vit|hvid|wit|silver|silber|argent|argento|plata|prata|zilver|s\u00f8lv/.test(t)) tone = 'silver';
      else if (/ros/.test(t)) tone = 'rose';
      else if (/gold|goud|\bor\b|oro|ouro|guld/.test(t)) tone = 'gold';
      if (!tone) continue;
      var group = l.closest('details, .facets__disclosure');
      var title = group ? (group.querySelector('.facets__summary-title') || {}).textContent || '' : '';
      if (/type|typ|tipo|sort|availab|verf|dispon|beschikb|stock/i.test(title)) continue;
      var dot = document.createElement('span');
      dot.className = 'collv2-dot is-' + tone;
      dot.setAttribute('aria-hidden', 'true');
      l.insertBefore(dot, l.firstChild);
    }
  }

  /* QA round 2: the toolbar's "Items: N" is outside the part of the page the
     theme re-renders on filter, so it kept the unfiltered count. The grid
     carries the filtered total (data-total); mirror it. */
  function itemsCount() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.total) return;
    var els = document.querySelectorAll('.facets__product-count-text');
    for (var i = 0; i < els.length; i++) {
      var t = els[i].textContent;
      var n = t.replace(/\d+(?!.*\d)/, grid.dataset.total);
      if (n !== t) els[i].textContent = n;
    }
  }

  function run() {
    itemsCount();
    heading();
    showMore();
    swatches();
    labelCards();
    buildToggle();
    applyView(currentMode());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The grid re-renders on filter, sort and load-more. */
  var host = document.querySelector('#main-collection-product-grid, .collection, main');
  if (host && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 120);
    }).observe(host, { childList: true, subtree: true });
  }
})();

/* Type tabs are single-choice (Johannes 2026-10-01): the theme renders them as
   checkboxes, so several could be ticked. Ticking one now unticks the others
   before the theme's own filter handler (bubble phase) reads the form. */
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox' || !input.closest || !input.closest('.facets_tags')) return;
    if (!input.checked) return;
    var wrap = input.closest('.facets_tags');
    wrap.querySelectorAll('input[type=checkbox]:checked').forEach(function (other) {
      if (other !== input) other.checked = false;
    });
  }, true);
})();

/* Escape closes the filter panel (QA 2026-10-09), through the panel's own
   close button so the theme's classes and timings stay in step. */
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !document.body.classList.contains('filter-open')) return;
    var c = document.querySelector('.facets__container.active .facets-modal__close') ||
            document.querySelector('.facets-modal__close');
    if (c) c.click();
  });
})();

/* Swipe hint on the first product card (Johannes 2026-10-10, same as the
   product page gallery): on phones, shortly after the collection loads, the
   first card's photo slider pulls about 8% to the left and springs back, so
   shoppers see the cards hold more photos. Once per visit, only if the card
   has more than one photo and is on screen, never after the shopper touched
   it, and off for reduced motion. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem('dCollNudge')) return; } catch (e) {}
  var touched = false, tries = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest && e.target.closest('.card-wrapper .swiper')) touched = true;
  }, { passive: true, capture: true });
  function go() {
    var el = [].slice.call(document.querySelectorAll('.card-wrapper .swiper.swiper-initialized')).filter(function (s) { return s.offsetParent !== null; })[0];
    var s = el && el.swiper;
    if (!s) { if (++tries < 20) setTimeout(go, 250); return; }
    // the card may open on its model photo (Model view), so nudge from wherever it is
    if (touched || s.destroyed || s.slides.length < 2 || s.isEnd) return;
    var r = el.getBoundingClientRect();
    if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
    try { sessionStorage.setItem('dCollNudge', '1'); } catch (e) {}
    var at = s.activeIndex, from = s.translate;
    s.translateTo(from - Math.round(s.width * 0.08), 380, false, false);
    setTimeout(function () { if (!s.destroyed && s.activeIndex === at && !touched) s.translateTo(from, 420, false, false); }, 600);
  }
  function start() { setTimeout(go, 900); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
